import type { GameMeta } from '@gmp/game-sdk';

export const boulderBashMeta = {
  id: 'boulder-bash',
  name: 'Boulder Bash',
  tagline: 'Roll boulders at forts while your rival digs trenches.',
  description:
    'A build-and-launch duel on a quarry slope. Defenders secretly drop ramps, barriers, trenches, bumpers and spinners into set slots; attackers secretly pick a lane and a rack of boulders, then aim and launch them live while defenders slam gates and tilt ramps. Everyone attacks and defends equally often.',
  minPlayers: 2,
  maxPlayers: 4,
  estimatedMinutes: [5, 8],
  usesMedia: false,
  modes: [{ id: 'siege', name: 'Siege', description: 'Everyone attacks and defends the same number of rounds. Most points wins.' }],
  theme: { primary: '#c8a26b', secondary: '#6ee7b7', background: '#15110b', ink: '#fbf3e6' },
  readiness: 'beta',
  genre: 'Build-and-launch duel',
  controls: 'tap',
  category: 'versus',
  instructions: [
    { icon: 'Shield', title: 'Defenders build', body: 'Spend your 18 points (split with a teammate) on ramps, barriers, trenches, bumpers, spinners and mud, and drop them into slots on the slope. Nobody sees your fort until the reveal.' },
    { icon: 'Mountain', title: 'Attackers load up', body: 'Secretly pick a lane and spend 24 points (split with a teammate) on a rack of up to 12 boulders: cheap Rollers, smashing Granite, trench-hopping Rubber Rocks or Splitters that burst into three.' },
    { icon: 'Crosshair', title: 'Aim, hold, release', body: 'Drag to aim, hold Launch to build power, let go to roll. Tap Split to burst a Splitter mid-roll.' },
    { icon: 'DoorClosed', title: 'Defend live', body: 'Slam a gate shut in a lane just before a boulder hits, or Tilt to flip your ramps and spinners. Each has two charges a round.' },
    { icon: 'Trophy', title: 'Score', body: 'Attackers score fort damage, plus bonuses for breaching a wall and bank shots. Defenders score the damage they prevent, plus a bonus for every boulder they stop. Roles swap every round.' },
  ],
} satisfies GameMeta;
